import data from './menuData.json';

export const menuData = data;
